export default {
  install(Vue) {
    /**
     * Shortens long number to use k formatting
     * @example 10000 becomes "10k", 32500 becomes "32.5k"
     * @param {number} num Number to be formatted
     * @returns Formatted number string
     */
    Vue.prototype.$kFormatter = (num) =>
      Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
  },
};
